import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Page, Text } from '@react-pdf/renderer';
import { ReservationType } from '../../../interfaces/reservation';
import ReservationDetailsPdf from '../ReservationDetailsPdf';

const ReservationDetailsListPdf = ({ data, guestFields, showLine1Address }) => (
  <Fragment>
    {data.map(each => (
      <ReservationDetailsPdf
        key={`reservation-${each.id}`}
        data={each}
        guestFields={guestFields}
        showLine1Address={showLine1Address}
      />
    ))}
    {!data.length && (
      <Page>
        <Text style={{ textAlign: 'center', marginTop: 20, fontSize: 12 }}>
          No Reservations Found
        </Text>
      </Page>
    )}
  </Fragment>
);

ReservationDetailsListPdf.propTypes = {
  data: PropTypes.arrayOf(ReservationType).isRequired,
  guestFields: PropTypes.shape({}).isRequired,
  showLine1Address: PropTypes.bool.isRequired
};

export default ReservationDetailsListPdf;
